/**
 * Slideshow - Initializes A11YSlider on slideshow elements with
 * custom arrow positioning, accessibility attributes, and text removal.
 */

import A11YSlider from 'a11y-slider';

function positionArrows(
    dots: HTMLElement,
    prev: HTMLElement,
    next: HTMLElement,
): void {
    const prevPos = dots.offsetLeft + dots.offsetWidth;
    const nextPos = prevPos + prev.offsetWidth;

    prev.style.left = prevPos + 'px';
    next.style.left = nextPos + 'px';
}

function addAttrToArrows(prev: HTMLElement, next: HTMLElement): void {
    prev.setAttribute('aria-label', 'Previous Slide');
    next.setAttribute('aria-label', 'Next Slide');
}

function removeArrowText(prev: HTMLElement, next: HTMLElement): void {
    prev.textContent = '';
    next.textContent = '';
}

export function setupSlideshow(): void {
    const slideshows = document.querySelectorAll<HTMLElement>('[data-a11y-slider]');

    slideshows.forEach((slideshow) => {
        const parent = slideshow.parentElement;

        slideshow.addEventListener('init', () => {
            if (!parent) return;

            const a11yPrev = parent.querySelector<HTMLElement>('.a11y-slider-prev');
            const a11yNext = parent.querySelector<HTMLElement>('.a11y-slider-next');
            const a11yDots = parent.querySelector<HTMLElement>('.a11y-slider-dots');

            if (!parent.classList.contains('a11y-init')) {
                parent.classList.add('a11y-init');
            }

            if (a11yDots && a11yPrev && a11yNext) {
                positionArrows(a11yDots, a11yPrev, a11yNext);
                addAttrToArrows(a11yPrev, a11yNext);
                removeArrowText(a11yPrev, a11yNext);
            }
        });

        new A11YSlider(slideshow, {
            slidesToShow: 1,
            container: true,
            skipBtn: false,
            dots: true,
            arrows: true,
        });
    });
}

// Auto-initialize when loaded as entry
setupSlideshow();
